import { NgModule } from "@angular/core";
import { WaitLoaderComponent } from "./wait-loader.component";

@NgModule({
    declarations: [
        WaitLoaderComponent
    ],
    imports: [
    ],
    exports: [WaitLoaderComponent]
})
export class WaitLoaderModule { }
